"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnActionsMenu = void 0;
var components_1 = require("@apollo/client/react/components");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var data_structures_1 = require("@tableau/data-structures");
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var queries_1 = require("../../../gen-src/queries");
var ColumnDetailsDialog_1 = require("../ColumnDetails/ColumnDetailsDialog");
var RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
var ReRenderPlacePageContext_1 = require("../placePage/ReRenderPlacePageContext");
var renderQueryResult_1 = require("../renderQueryResult");
var ColumnActions;
(function (ColumnActions) {
    ColumnActions["Tags"] = "Tags";
    ColumnActions["Description"] = "Edit Description";
    ColumnActions["QualityWarning"] = "Quality Warning";
    ColumnActions["SensitiveLabels"] = "Edit Sensitivity Label";
})(ColumnActions || (ColumnActions = {}));
var noop = function () { return; };
var actionsMenuStyle = {
    marginLeft: widgets_1.TabStyles.Spacing.MediumSpace,
};
function ColumnActionsMenu(props) {
    var _a = react_1.default.useState(''), actionItem = _a[0], setActionItem = _a[1];
    var _b = react_1.default.useState(false), isDialogShowing = _b[0], setIsDialogShowing = _b[1];
    var columnIdsStringList = (0, data_structures_1.keySetToStringList)(props.columnIds);
    var rerender = react_1.default.useContext(ReRenderPlacePageContext_1.ReRenderPlacePageContext).rerender;
    var canUserSetColumnDescription = react_1.default.useContext(data_catalog_shared_1.ApiRequestsContext).canUserSetColumnDescription;
    var _c = react_1.default.useContext(data_catalog_shared_1.UIActionsContext), renderDataQualityDialog = _c.renderDataQualityDialog, renderSensitiveLabelsDialog = _c.renderSensitiveLabelsDialog;
    var sensitiveLabelsEnabled = react_1.default.useContext(data_catalog_shared_1.FeatureFlagsContext).sensitiveLabelsEnabled;
    var _d = react_1.default.useState(false), canUpdate = _d[0], setCanUpdate = _d[1];
    react_1.default.useEffect(function () {
        var _a;
        canUserSetColumnDescription({ tableVizportalId: (_a = props.tableVizportalId) !== null && _a !== void 0 ? _a : '' })
            .then(function (r) { return setCanUpdate(r); })
            .catch(function () { return; });
    }, [canUserSetColumnDescription, props.tableVizportalId]);
    var columnId = columnIdsStringList && columnIdsStringList[0] ? columnIdsStringList[0] : null;
    if (!columnId) {
        return null;
    }
    return (react_1.default.createElement(components_1.Query, { 
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        query: queries_1.ColumnDetailsByLuidDocument, variables: { columnId: columnId } }, function (result) { return react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: {
            renderData: function (data) {
                var column = data && data.columns && data.columns[0] ? data.columns[0] : null;
                if (!column) {
                    return null;
                }
                var qualityActionItem = {
                    value: ColumnActions.QualityWarning,
                    content: Localize_1.Messages.DataQualityWarningAction(),
                    disabled: !canUpdate || !column.luid,
                };
                var sensitiveLabelActionItem = {
                    value: ColumnActions.SensitiveLabels,
                    content: Localize_1.Messages.SensitiveLabelAction(),
                    disabled: !canUpdate || !column.luid,
                };
                var columnActionItems = [
                    {
                        value: ColumnActions.Tags,
                        content: Localize_1.Messages.TagsAction(),
                        disabled: !canUpdate,
                    },
                    {
                        value: ColumnActions.Description,
                        content: Localize_1.Messages.EditDescriptionAction(),
                        disabled: !canUpdate,
                    },
                    qualityActionItem
                ];
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(widgets_1.SingleSelectDropdown, { type: widgets_1.DropdownButtonType.Line, label: '', list: react_1.default.createElement(widgets_1.List, { items: sensitiveLabelsEnabled ? columnActionItems.concat(sensitiveLabelActionItem) : columnActionItems }), testId: 'columns-actions-menu', onChange: function (value) {
                            var _a, _b;
                            if (value === ColumnActions.QualityWarning && (column === null || column === void 0 ? void 0 : column.luid)) {
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                                renderDataQualityDialog({
                                    content: {
                                        contentId: column.luid,
                                        contentName: (_a = column.name) !== null && _a !== void 0 ? _a : '',
                                        contentType: 'column',
                                        contentIcon: (react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: column.remoteType })),
                                    },
                                    dismiss: function () {
                                        rerender();
                                    },
                                }).catch(function (_) { return; });
                            }
                            else if (value === ColumnActions.SensitiveLabels && (column === null || column === void 0 ? void 0 : column.luid)) {
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                                renderSensitiveLabelsDialog({
                                    content: {
                                        contentId: column.luid,
                                        contentName: (_b = column.name) !== null && _b !== void 0 ? _b : '',
                                        contentType: 'column',
                                        contentIcon: (react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: column.remoteType })),
                                    },
                                    dismiss: function () {
                                        rerender();
                                    },
                                }).catch(function (_) { return; });
                            }
                            else {
                                setIsDialogShowing(true);
                                setActionItem(value);
                            }
                        }, style: actionsMenuStyle }, Localize_1.Messages.Actions()),
                    isDialogShowing &&
                        (actionItem === ColumnActions.Tags || actionItem === ColumnActions.Description) &&
                        react_1.default.createElement(ColumnDetailsDialog_1.ColumnDetailsDialogQueryWrapper, { columnId: columnIdsStringList[0], tableVizportalId: props.tableVizportalId, onClose: function () { return setIsDialogShowing(false); }, afterDescriptionChange: noop })));
            }
        } }); }));
}
exports.ColumnActionsMenu = ColumnActionsMenu;
//# sourceMappingURL=ColumnActionsMenu.js.map